/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

import TurnLeftIcon from '@mui/icons-material/TurnLeft';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';

const whiteSpacePreLine = {
  '& > span, & > p': {
    whiteSpace: 'pre-line !important',
    fontSize: '14px',
    lineHeight: '16px',
  },
};

const coloredText = (color?: string) => ({
  '& > span, & > p': {
    color: `${color || 'inherit'} !important`,
    fontSize: '14px',
    lineHeight: '16px',
  },
});

export const BreadcrumbsContainer = styled(Box)(({theme}) => ({
  margin: theme.spacing(4, 0, 8, 0),
}));

export const PeriodSelectorContainer = styled(Box)(({theme}) => ({
  margin: theme.spacing(4, 0),
  display: 'flex',
  gap: theme.spacing(4),
  flexWrap: 'wrap',

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'nowrap',
    flexDirection: 'column',
  },
}));

export const DateCell = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  '& > p': {
    whiteSpace: 'normal !important',
  },
}));

export const ValueChangeCellHorizontal = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  ...whiteSpacePreLine,
}));

export const ValueChangeCellVertical = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  ...whiteSpacePreLine,
}));

export const ValueChangeCellBeforeText = styled(Box)(({theme}) => ({
  ...coloredText(theme.palette.figma_red_5?.main),
}));

export const ValueChangeCellAfterText = styled(Box)(({theme}) => ({
  ...coloredText(theme.palette.figma_blue_1?.main),
  '& > p': {
    whiteSpace: 'pre-line !important',
  },
}));

export const ValueChangeCellArrow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 16,
}));

export const ValueChangeCellArrowContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(0.5),
}));

export const GoBackButton = styled(PrimaryMediumButton)(({theme}) => ({
  padding: theme.spacing(3, 6),
  borderRadius: theme.spacing(2),
  background: theme.palette.figma_gray_dark_1?.main,
  color: theme.palette.figma_gray_light_1?.main,
  fontSize: 14,
  fontWeight: 400,
  flexShrink: 0,

  '&:hover': {
    background: theme.palette.figma_gray_dark_2?.main,
  },
}));

export const GoBackIcon = styled(TurnLeftIcon)(({theme}) => ({
  marginRight: theme.spacing(2),
  alignSelf: 'start',
}));

export {ResetButton as DownloadExcelButton} from 'components/Table/core/components/FilterBar/styles';
